import React from 'react';

import { TermsContent } from '../content/termsContent';
import LegalPageLayout from '../layouts/LegalPageLayout';

export default function TermsAndConditions() {
  return (
    <LegalPageLayout title="Terms And Conditions">
      <TermsContent />
    </LegalPageLayout>
  );
}
